// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a15317d","455":"b4c3b58d","977":"0c370809"}[chunkId] + ".chunk.js";
};